import type { AuthRepository, SignUpCommand, SignUpResponse } from '../repository/AuthRepository';

export class SignUpUseCase {
  constructor(private readonly repository: AuthRepository) {}

  async execute(command: SignUpCommand): Promise<SignUpResponse> {
    // 모든 검증/정규화는 UseCase에서 수행 (TDD 타겟)
    if (!command.first_name?.trim()) throw new Error('first_name is required');
    if (!command.last_name?.trim()) throw new Error('last_name is required');
    if (!command.email?.trim()) throw new Error('email is required');
    if (!command.partner?.trim()) throw new Error('partner is required');
    if (!command.user_passwd) throw new Error('user_passwd is required');

    return this.repository.signUp({
      ...command,
      first_name: command.first_name.trim(),
      last_name: command.last_name.trim(),
      email: command.email.trim(),
      partner: command.partner.trim(),
    });
  }
}


